import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { Installation } from "@/components/sections/Installation";
import { Gallery } from "@/components/sections/Gallery";
import { Process } from "@/components/sections/Process";
import { Battery } from "@/components/sections/Battery";
import { Credentials } from "@/components/sections/Credentials";
import { FinalCta } from "@/components/sections/FinalCta";
import { LeadForm } from "@/components/sections/LeadForm";

export default function InstallationPage() {
  return (
    <main data-testid="installation-page">
      <Seo path="/solar-installation" title="Solar Panel Installation in Texas | Solar Energy Doc"
        description="Professional solar panel installation throughout Texas — system design, inverters, monitoring, electrical and battery integration. Licensed, insured and Tesla, Enphase & SolarEdge certified." />
      <PageHero eyebrow="Solar Installation · Texas" service="Solar Installation" testId="installation-page-hero"
        lines={["Solar installation,", "engineered for Texas."]}
        sub="Professional solar panel installation for Texas homes and businesses — designed around your property and your energy needs, and backed by certified technicians." />
      <Installation index="01" />
      <Gallery />
      <Credentials />
      <Process />
      <Battery index="05" />
      <FinalCta />
      <LeadForm />
    </main>
  );
}
